import React from 'react'
import PropTypes from 'prop-types'
import esAPI from '../../services/esAPI/esAPI'
import Error from '../../components/status/Error'
import Loading from '../../components/status/Loading'

class ContactApi extends React.Component {
  state = {
    loading: false,
    error: false,
    content: null,

    contactUs: values => esAPI('post', '/contact-us', values).then(this.props.onCompleted),
  }

  componentDidMount() {}

  render() {
    const { contactUs, loading, error } = this.state
    const { children } = this.props

    if (loading) {
      return <Loading />
    }

    if (error) {
      return <Error>There was an error sending your message. Please try again in a minute.</Error>
    }

    return children(contactUs)
  }
}

ContactApi.propTypes = {
  children: PropTypes.func.isRequired,
}

export default ContactApi
